import { ErrorResource } from "../locales";

export const error: ErrorResource = {
    couldNotSave: "Impossible d'enregistrer",
    ohNoSomethingWentWrong: "Oh non, quelque chose s'est mal passé !  :(",
    refreshAndTryAgain: "Actualisez la page et réessayez.",
    goToLogin: "Aller à Connexion",
};
